import React from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as FacebookIcon } from "../../../assets/svg/facebook-icon.svg";
import { setActiveModule } from "../../../actions/sideBarActions";

const Fb = () => {
    const dispatch = useDispatch();
    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                explore_fb: 1,
            },
        };
        localStorage.setItem("activeModule", "Page Analytics");
        dispatch(setActiveModule("Page Analytics"));
        dispatch(configure_getting_started_progress(obj));
    };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <FacebookIcon className="icon_content" />
                        <span className="content_title">Facebook</span>
                    </div>
                    <div className="text_content">
                        <p>{`This section will provide insights of your connected facebook pages.`}</p>
                        <p>{`
Facebook Insights gives you aggregated information about two groups of people - people connected to your Page and people on Facebook - so you can create content that resonates and easily find more people like the ones in your current audience. Connect your Facebook pages and start checking insights
`}</p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    <Link to="/owned-page/facebook">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/1qsUXnKBMDk"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default Fb;
